import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Grid, Button, Input, Checkbox } from 'semantic-ui-react';
import cm from 'helpers/commons';
import { DateForm, TableForm, StaffSearchModal, Pagination } from 'components/Commons';
// eslint-disable-next-line camelcase
import * as cm_action from 'actions/commons';
// eslint-disable-next-line camelcase
import * as usg_action from 'actions/usage';
import moment from 'moment-timezone';

class OurhomeSubtractStat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pagerow: 15,
      staff: {
        name: '',
        id: ''
      },
      staffModal: {
        open: false,
        size: 'large'
      },
      check: true
    };
  }

  componentWillMount() {
    this.submitForm();
  }

  submitForm = async () => {
    const { date, usageAPI, cmAPI } = this.props;
    const { page, pagerow, staff } = this.state;
    const params = {
      startdate: date
        ? moment(date.sDate).format('YYYY-MM-DD')
        : moment()
            .startOf('month')
            .format('YYYY-MM-DD'),
      enddate: date ? moment(date.eDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      keyword: staff.name === '' ? null : staff.name,
      page,
      pageRow: pagerow
    };
    await usageAPI.ourhomeStatList(params);
    cmAPI.changeExcel({
      excel: params
    });
  };

  modalAction = (type, dimmer) => {
    if (type === 'open') {
      this.staffSel(1, null);
    }
    this.setState({
      dimmer,
      staffModal: { open: dimmer }
    });
  };

  searchClick = () => {
    const { check } = this.state;
    if (!check) {
      this.modalAction('open', true);
    }
  };

  choiceStaff = (data) => {
    this.setState({
      staffModal: { open: false },
      staff: {
        name: data ? data.staff.name : '',
        id: data ? data.staff.id : ''
      }
    });
  };

  staffSel = async (page, keyword) => {
    const { cmAPI } = this.props;
    const params = { page, pagerow: 10, keyword };
    try {
      await cmAPI.staffSel(params);
    } catch (e) {
      console.log('###### staffSel error : ', e);
    }
  };

  pageClick = async (page) => {
    await this.setState({ page });
    this.submitForm();
  };

  render() {
    const { ourhomeStatList } = this.props;
    const { staffModal, dimmer, staff, check } = this.state;
    const header = [
      { data: '날짜', textAlign: 'left' },
      { data: 'ID', textAlign: 'left' },
      { data: '이름', textAlign: 'left' },
      { data: '식대그룹', textAlign: 'left' },
      { data: '회사식대', textAlign: 'right' },
      { data: '아워홈 차감 포인트', textAlign: 'right' }
    ];
    const column = cm.tableHeaderList(header, 3, null, 'default');

    let page;
    let pagerow;
    let totalcount;

    const tabledata = {
      header: { main: column },
      body: { message: '검색 결과가 없습니다.', main: null }
    };

    if (ourhomeStatList && ourhomeStatList.data) {
      const { paging, stat, total } = ourhomeStatList.data;

      if (paging) {
        page = paging.page + 1;
        pagerow = paging.pagerow;
        totalcount = paging.totalcount;
      }
      if (stat && stat.length > 0) {
        if (total) {
          tabledata.header.sub = [
            {
              data: '합계',
              colSpan: column.length - 2,
              textAlign: 'left'
            },
            {
              data: cm.numberComma(total.policyTotalAmount),
              textAlign: 'right'
            },
            {
              data: cm.numberComma(total.subTractTotalAmount),
              textAlign: 'right'
            }
          ];
        }
        tabledata.body.main = stat.map((item) => {
          let rowData = {
            row: [
              { data: moment(item.useDate).format('YYYY-MM-DD'), textAlign: 'left' },
              { data: item.signId, textAlign: 'left' },
              { data: item.userName, textAlign: 'left' },
              { data: item.groupName, textAlign: 'left' },
              { data: cm.numberComma(item.policyAmount), textAlign: 'right' },
              { data: cm.numberComma(item.ourhomeSubtractPoint), textAlign: 'right' }
            ]
          };
          rowData = cm.defalutTableStaffDivisionSet(rowData.row, 3, item.orgCode);
          return rowData;
        });
      }
    }
    const modal = {
      open: staffModal.open,
      size: staffModal.size,
      dimmer,
      close: this.modalAction
    };
    return (
      <Form onSubmit={this.submitForm} className="top-form orh">
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14}>
              <DateForm />
            </Grid.Column>
            <Grid.Column width={2} className="right">
              <Button inverted color="black" content="조회" />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group inline style={{ margin: '4px 0px 8px' }}>
                <Checkbox onChange={() => this.setState({ check: !check })} />
                <Input
                  className="bind"
                  value={staff.name}
                  labelPosition="right"
                  disabled={check}
                  action={{
                    icon: 'search',
                    type: 'button',
                    onClick: this.searchClick
                  }}
                  onClick={this.searchClick}
                  label={{
                    basic: true,
                    content: 'x',
                    onClick: () => this.choiceStaff(null)
                  }}
                  placeholder="사용자 전체"
                />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <TableForm selectable="true" tabledata={tabledata} />
        <div className="table-paging">
          <Pagination page={page} pageRow={pagerow} pageBlock={10} totalCount={totalcount} pageClick={this.pageClick} />
        </div>
        <StaffSearchModal modal={modal} staffSel={this.staffSel} choiceEvent={this.choiceStaff} />
      </Form>
    );
  }
}

// eslint-disable-next-line no-class-assign
OurhomeSubtractStat = connect(
  (state) => ({
    date: state.commons.date,
    ourhomeStatList: state.usage.ourhomeStatList
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        staffSel: cm_action.StaffSel,
        changeExcel: cm_action.ChangeExcel
      },
      dispatch
    ),
    usageAPI: bindActionCreators(
      {
        ourhomeStatList: usg_action.OurhomeStatsList
      },
      dispatch
    )
  })
)(OurhomeSubtractStat);

export default OurhomeSubtractStat;
